/**
 * ByokPaywall — candado del plan mensual sobre la config BYOK (T-087).
 *
 * BYOK (llave propia + elección de modelos) es beneficio del plan mensual:
 * consulta GET /me/credits y, sin plan activo, muestra el contenido borroso e
 * inerte con un CTA a /planes. El paywall real (server-side) sigue siendo el
 * gate 402 de `enforce_subscription`; esto es la cara visible en la UI.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../lib/axios';
import { Button } from './ui/button';
import { Lock } from 'lucide-react';

const ByokPaywall = ({ children }) => {
  const navigate = useNavigate();
  const [active, setActive] = useState(null); // null = verificando

  useEffect(() => {
    let alive = true;
    axiosInstance.get('/me/credits')
      .then((r) => { if (alive) setActive(!!r.data?.subscription?.active); })
      .catch(() => { if (alive) setActive(false); });
    return () => { alive = false; };
  }, []);

  if (active) return children;

  return (
    <div className="relative">
      <div className="pointer-events-none select-none blur-[3px] opacity-40" aria-hidden="true">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="glass rounded-xl border border-white/30 shadow-lg p-6 max-w-sm text-center space-y-3">
          <Lock className="w-8 h-8 mx-auto text-violet-500" />
          <h3 className="font-semibold text-lg">Función del plan mensual</h3>
          <p className="text-sm text-slate-600 dark:text-slate-300">
            {active === null
              ? 'Verificando tu plan…'
              : 'Usar tu propia llave de OpenRouter (BYOK) y elegir modelos requiere el plan mensual de plataforma.'}
          </p>
          {active === false && (
            <Button
              data-testid="byok-paywall-cta"
              onClick={() => navigate('/planes')}
              className="w-full bg-gradient-to-r from-violet-500 to-purple-600 hover:from-violet-600 hover:to-purple-700 text-white"
            >
              Ver planes y precios
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ByokPaywall;
